import { render } from "./List.vue?vue&type=template&id=4ce4fa56&ts=true&lang=pug"
import script from "./List.vue?vue&type=script&lang=ts"
export * from "./List.vue?vue&type=script&lang=ts"

import "./List.vue?vue&type=style&index=0&id=4ce4fa56&lang=scss"

import exportComponent from "C:\\Users\\ZiegFreeze\\Documents\\Work\\upa-fast-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__